import { Route } from 'vue-router';
import store from '@/store';

export default async (to, from, next) => {
  await accessoriesGuard(to, from, next);
  
  return next();
};

async function accessoriesGuard(to, from, next) {
  const regexp = /^\/accessories/;
  const leavingAccessories = !regexp.test(to.path);
  if (leavingAccessories) await store.dispatch('accessoryCategories/changeSelectedCategories', []);
}
